import "react-toastify/dist/ReactToastify.css";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { useEffect } from "react";
import BannerOverlay from "../components/BannerOverlay";
import waze from "../assets/svg/waze-white.svg";

const offices = [
    {
        name: "D&D Kuala Lumpur",
        subtitle: "(Headquarter)",
        lines: [
            "G22, 28 Blvd, Jln Perdana 3/10,",
            "Pandan Perdana, 55300",
            "Kuala Lumpur",
        ],
        image:
            "https://ik.imagekit.io/dnddecpho/dndream/WhatsApp-Image-2025-02-25-at-15.36_AAx1s3IaZ.png?updatedAt=1740491316830",
        waze: "https://www.waze.com/zh/live-map/directions/my/selangor/kuala-lumpur/dandd-real-estate-sdn-bhd?to=place.ChIJp8uMi-43zDERREDXbBhDUKE",
    },
    {
        name: "D&D Johor Bahru",
        subtitle: "(Branch)",
        lines: [
            "1-03, Jalan Kota, 3, ,",
            "Taman Cahaya Kota Puteri, 81750",
            "Johor Darul Ta'zim",
        ],
        image:
            "https://ik.imagekit.io/dnddecpho/dndream/Branch-JB_FsamxVg5p.jpg?updatedAt=1739987835423",
        waze: "https://www.waze.com/zh/live-map/directions/my/johor-darul-tazim/masai/dandd-real-estate-(-jb-branch-)?to=place.ChIJBUUrLo1r2jER09MPlA1HtgY",
    },
    {
        name: "D&D Melaka",
        subtitle: "(Branch)",
        lines: ["1-1, Jalan KSB 17,", "Melaka, 75200", "Melaka"],
        image:
            "https://ik.imagekit.io/dnddecpho/dndream/Branch-Melaka_UtxqDdCs3.jpg?updatedAt=1739987835415",
        waze: "https://www.waze.com/zh/live-map/directions/my/melaka/melaka/danddream-property-group-(mlk-branch)?to=place.ChIJ0xVx6ELx0TER-hydhWQiaLA",
    },
    {
        name: "D&D Ipoh",
        subtitle: "(Branch)",
        lines: [
            "No.39C, Third Floor, Hala Pusat Perdagangan Canning,",
            "1, Jln Pusat Perdagangan Canning 2, 30350",
            "Ipoh, Perak",
        ],
        image:
            "https://ik.imagekit.io/dnddecpho/dndream/Branch-Ipoh_azxTWADAD.jpg?updatedAt=1739987835411",
        waze: "https://www.waze.com/zh/live-map/directions/my/perak/ipoh/dandd-property-group-(ipoh)?to=place.ChIJ7cIhhintyjERNrbEKXqexlU",
    },
];

const Contact = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="m-0 p-0" style={{ background: "var(--brand-black)" }}>
            <Header />
            <BannerOverlay
                imageUrl="https://ik.imagekit.io/dnddecpho/dndream/D&D_Website_WebBanner_1920x500px_PC5_dHeFNDqxfZ.jpg?updatedAt=1731826250680"
                title=""
            />
            <section className="section-shell">
                <div className="section-block" style={{ paddingBottom: "2rem" }}>
                    <h2 className="section-title">D&D OFFICES</h2>
                </div>
                <div className="office-grid">
                    {offices.map((office) => (
                        <article key={office.name} className="office-card">
                            <img
                                className="office-card-photo"
                                src={office.image}
                                alt={office.name}
                            />
                            <div className="office-name">{office.name}</div>
                            <div className="office-subtitle">
                                {office.subtitle}
                            </div>
                            {office.lines.map((line) => (
                                <div key={line} className="office-address">
                                    {line}
                                </div>
                            ))}
                            <a
                                href={office.waze}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="office-waze"
                                aria-label={`Open ${office.name} in Waze`}
                            >
                                <img src={waze} alt="" />
                            </a>
                        </article>
                    ))}
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default Contact;
